import { Inject, Injectable } from '@angular/core'
import { APP_CONFIG } from '../../configuration/ticket-management-portal-configuration'
import { TicketManagementPortalConfiguration } from '../../configuration/ticket-management-portal-configuration.model'
import { DVM_CONFIG } from '../digitalvenue.configuration'
import { DVMConfiguration } from '../dvmconfiguration.model'
import { APIConnectionService } from '../services/api-connection.service'
import { DVMService } from '../services/dvm.service'
import { FlowControlService } from '../services/flow-control.service'
import { PricingService } from '../services/pricing.service'
import { GeneralHandler } from './general.handler'
import { UserService } from "../../services";
import { ConfigurationService } from "../../services/configuration.service";

@Injectable()
export class LoadHandler extends GeneralHandler {
    customerPlanBuyerTypes: string [] = [];
    constructor(
      @Inject(DVM_CONFIG) private dvmConfig: DVMConfiguration,
      @Inject(APP_CONFIG) private appConfig: TicketManagementPortalConfiguration,
                private flowControl: FlowControlService,
                private pricing: PricingService,
                private connection: APIConnectionService,
                protected dvmService: DVMService,
                private userService: UserService,
                private configurationService: ConfigurationService) {
        super('end_load', dvmService);
    }

    loadBlockmapHandler(viewer) {
        viewer.setAvailability([]);
        this.flowControl.availabilty.next([]);
        this.flowControl.showLoader(true);
        if (this.flowControl.isFlex && !this.flowControl.upgradePlan) {
            this.flowControl.showLoader(false);
            return;
        }
        this.connection.getPlanAvailability(this.flowControl.currentPlan, this.flowControl.upgradePlan).subscribe(
            planAvailability => {
                let planAvailabilityCopy = {};
                // https://mmcbcn.atlassian.net/browse/TICKETING-1676
                if ( this.configurationService.client === 'athletics') {
                  // tslint:disable-next-line:forin
                  for (const sectionID in planAvailability) {
                    const section = planAvailability[sectionID];
                    for (const buyerType of section.buyer_type) {
                      if  (this.customerPlanBuyerTypes.includes(buyerType.id.toString())) {
                        console.log('found');
                        planAvailabilityCopy[sectionID] = section;
                        break;
                      }
                    }
                  }
                } else {
                  planAvailabilityCopy = planAvailability;
                }
                console.log(planAvailabilityCopy);
              // @ts-ignore
              this.flowControl.availabilty.next(planAvailabilityCopy);
                // tslint:disable-next-line: forin
                for (const areaId in planAvailabilityCopy) {
                    this.pricing.areapricing[areaId] = {
                        min: planAvailabilityCopy[areaId]['min_price'] ? planAvailabilityCopy[areaId]['min_price'].toFixed(2) : 0,
                        max: planAvailabilityCopy[areaId]['max_price'] ? planAvailabilityCopy[areaId]['max_price'].toFixed(2) : 0,
                    };
                }
                this.flowControl.latestAreaAvailability = Object.keys(planAvailabilityCopy);
                //Seteamos Availability según flex mode
                this.flowControl.flexMode ?
                viewer.setAvailable('section',this.mergeAllSections(planAvailabilityCopy)) : // Nueva
                viewer.setAvailable('section', Object.keys(planAvailabilityCopy));           // Original
                // viewer.setAvailable('section', Object.keys(this.flowControl.suitesHash));
                // viewer.setNodesTag(Object.keys(this.flowControl.suitesHash), 'vip');
                // viewer.setNodesTag(Object.keys(this.flowControl.greenSuites), 'vipGreen');
                if (!this.flowControl.upgradePlan) {
                    this.connection.getPlanSeats(this.flowControl.currentPlan).subscribe(
                        basket => {
                            const basketArray = [];
                            for (const seat of basket) {
                                basketArray.push('S_' + seat['section']);
                            }
                            viewer.setNodesTag(basketArray, 'owned');
                            viewer.setAvailable('section', basketArray);
                            // status.blockmap.moduleRef['setStatus'](basketArray, 'owned');
                        },
                        error => {
                            console.error(error.message);
                        }
                    );
                }
                this.flowControl.showLoader(false);
            },
            error => {
                console.error(error);
                this.flowControl.showLoader(false);
            });

    }

    loadSeatmapHandler(viewer) {
        viewer.setAvailability([]);
        this.flowControl.showLoader(true);
        this.connection.getPlanSectionAvailability(this.flowControl.currentPlan,
            viewer.getMapId(), this.flowControl.upgradePlan).subscribe(
                planSectionAvailability => {
                    let planSectionAvailabilityCopy = {};
                    // https://mmcbcn.atlassian.net/browse/TICKETING-1676
                    if ( this.configurationService.client === 'athletics') {
                      // tslint:disable-next-line:forin
                      for (const seatId in planSectionAvailability) {
                        const seatInfo = planSectionAvailability[seatId];
                        for (const buyerType of seatInfo.price_type.prices) {
                          if  (this.customerPlanBuyerTypes.includes(buyerType.buyer_type_id.toString())) {
                            console.log('found');
                            planSectionAvailabilityCopy[seatId] = seatInfo;
                            break;
                          }
                        }
                      }
                    } else {
                      planSectionAvailabilityCopy = planSectionAvailability;
                    }
                    console.log(planSectionAvailabilityCopy);
                    // tslint:disable-next-line: forin
                    for (const seatId in planSectionAvailabilityCopy) {
                        this.pricing.seatpricing[seatId] = {price: planSectionAvailabilityCopy[seatId].price_type.prices[0].price,
                        price_type: planSectionAvailabilityCopy[seatId].price_type.name,
                        all_in_price: planSectionAvailabilityCopy[seatId].price_type.prices[0].all_in_price,
                          // twins needs to handle two buyer types https://mmcbcn.atlassian.net/browse/IT-2685
                        all_prices: planSectionAvailabilityCopy[seatId].price_type.prices};
                    }
                    viewer.setAvailable('seat', Object.keys(planSectionAvailabilityCopy));

                    if (!this.flowControl.upgradePlan) {
                        this.connection.getPlanSeats(this.flowControl.currentPlan).subscribe(
                            basket => {
                                const basketArray = [];
                                for (const seat of basket) {
                                    basketArray.push(seat['id']);
                                }
                                viewer.setNodesTag(basketArray, 'owned');
                                viewer.setAvailable('seat', basketArray);
                                // viewer.select(basketArray);
                            },
                            error => {
                                console.error(error.message);
                            }
                        );
                    }
                    this.flowControl.showLoader(false);
                },
                error => {
                    console.error(error);
                    this.flowControl.showLoader(false);
                }
            );

    }

    protected handle(error, viewer) {
        if (error) { console.error(error); }
        viewer = viewer.instance;
        const customerPlan = this.userService.getCustomerPlanById(this.flowControl.currentPlan);
        this.customerPlanBuyerTypes = [];
        for (const seat of customerPlan.customer_plan_seats) {
          this.customerPlanBuyerTypes.push(seat.price_code_name);
        }
        if (viewer.getMapId() === this.dvmConfig.map_id) {
            this.loadBlockmapHandler(viewer);
        } else {
            this.loadSeatmapHandler(viewer);
        }
    }

    //PARA TESTEO CON API CHELSEA
    private mergeAllSections(sections){
        //@ts-ignore
        return Object.values(sections).reduce((acc,val)=>(val.sections.forEach(s => acc.push(s.toString())),acc),[]);
    }
}
